export const environment = { isProduction: false,
  name:'Local',
  baseUrl: 'https://sas.carvia-test.org',
  issuer: 'https://sas.carvia-test.org',

};
